<template>
    <section class="relative w-full pt-24 pb-40 bg-gray-100">
        <LogoIllustrationSVG class="extra-logo-illustration" alt="illustration"/>
        <div class="extra-gutter">
            <div class="extra-content min-h-[500px]">

                <h2 class="py-24 text-lg font-medium text-gray-400 font-heading">{{ $t('error.msg') }}</h2>

            </div>
        </div>
    </section>
</template>

<script lang="ts">
import LogoIllustrationSVG from '@/assets/static/icons-src/logo-illustration.svg'
import { Component, Vue } from 'vue-property-decorator'

@Component({
    components: {
        LogoIllustrationSVG
    },
    metaInfo: {
        title: 'Page Not Found'
    }
})
export default class ErrorPage extends Vue {
    mounted () {
        console.log('Eroor page loaded')
    }
}
</script>

<style scoped>

</style>
